<template>
    <v-menu open-on-hover offset-y>
        <template v-slot:activator="{ on, attrs}">
            <v-btn text icon color="primary" class="mr-2" v-bind="attrs" v-on="on">
                <v-icon>mdi-cog</v-icon>
            </v-btn>
        </template>

        <v-list dense
                nav>
            <v-list-item
                    link
                    :to="{ name: 'SettingsUsers'}"
                    active-class="primary--text"
                    exact

            >
                <v-list-item-icon >
                    <v-icon>mdi-account-box-multiple</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Nutzer</v-list-item-title>
            </v-list-item>

            <!--<v-list-item
                    link
                    :to="{ name: 'SettingsOrgaUnits'}"
                    active-class="primary&#45;&#45;text"
                    exact
            >
                <v-list-item-icon >
                    <v-icon>mdi-google-circles-communities</v-icon>
                </v-list-item-icon>
                <v-list-item-title >Organisationseinheiten</v-list-item-title>
            </v-list-item>-->
        </v-list>
    </v-menu>
</template>

<script>
    export default {
        name: "app-layout-navbar-settings"
    }
</script>

<style scoped>

</style>